module.exports = __webpack_public_path__ + "img/logo-color.c33ea4aa.png";